import { render, staticRenderFns } from "./margin-payment.html?vue&type=template&id=666da7aa&scoped=true&external"
import script from "./margin-payment.js?vue&type=script&lang=js&external"
export * from "./margin-payment.js?vue&type=script&lang=js&external"
import style0 from "./margin-payment.scss?vue&type=style&index=0&id=666da7aa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666da7aa",
  null
  
)

export default component.exports